export const SUBSCRIPTION_SWITCHING_FLOW_MODULE_NAME = 'subscriptionSwitchingFlow';

export const SET_SUBSCRIPTION_SWITCHING_SYNCING_STATE = 'SET_SUBSCRIPTION_SWITCHING_SYNCING_STATE';
